import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbDatepickerModule, NgbPopoverModule, NgbTooltipModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { AngularDualListBoxModule } from 'angular-dual-listbox';

import { SmartyStreetsService } from '../../core/common/smart-streets.service';
import { AmazingTimePickerModule } from './atp-library/atp-time-picker.module';
import { CollapsibleDividerComponent } from './components/collapsible-divider/collapsible-divider.component';
import { ControlGroupComponent } from './components/control-group/control-group.component';
import { DateRangeComponent } from './components/date-range/date-range.component';
import { DualListBoxComponent } from './components/dual-list-box/dual-list-box.component';
import { FixedButtonsComponent } from './components/fixed-buttons/fixed-buttons.component';
import { GoogleAddressComponent } from './components/google-address/google-address.component';
import { RadioButtonListComponent } from './components/radio-button-list/radio-button-list.component';
import { StepsComponent } from './components/steps/steps.component';
import { TouchRadioButtonListComponent } from './components/touch-radio-button-list/touch-radio-button-list.component';
import { BackButtonDirective } from './directives/back-button/back-button.directive';
import { ControlRefDirective } from './directives/control-ref.directive';
import { CurrencyDirective } from './directives/masking/currency.directive';
import { CurrencyService } from './directives/masking/currency.service';
import { NumericDirective } from './directives/masking/numeric.directive';
import { PhoneExtDirective } from './directives/masking/phone-ext.directive';
import { SubmitUrlDirective } from './directives/submit-url.directive';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { SvgModule } from './svg/svg.module';
import { PcgSelectComponent } from './components/pcg-select-component/select.component';
import { ShowHidePasswordComponent } from './components/show-hide-password/show-hide-password.component';
import { NoHashDirective } from './directives/masking/no-hash.directive';
import { TextEditorComponent } from './text-editor/text-editor.component';

@NgModule({
	declarations: [
		ControlGroupComponent
		, ControlRefDirective
		, CollapsibleDividerComponent
		, PhoneExtDirective
		, StepsComponent
		, DateRangeComponent
		, DualListBoxComponent
		, RadioButtonListComponent
		, TouchRadioButtonListComponent
		, FileUploadComponent
		, FixedButtonsComponent
		, NumericDirective
		, CurrencyDirective
		, SubmitUrlDirective
		, BackButtonDirective
		, GoogleAddressComponent
		, PcgSelectComponent
		, ShowHidePasswordComponent
		, NoHashDirective
        , TextEditorComponent
	]
    , imports: [
		CommonModule
		, ReactiveFormsModule
		, FormsModule
		, SvgModule
		, NgbDatepickerModule
		, AmazingTimePickerModule
		, AngularDualListBoxModule
		, NgbPopoverModule
		, NgSelectModule
		, NgbTooltipModule
		, RouterModule
		, NgbTypeaheadModule
	]
    , exports: [
		ControlGroupComponent
		, ControlRefDirective
		, CollapsibleDividerComponent
		, PhoneExtDirective
		, NumericDirective
		, CurrencyDirective
		, StepsComponent
		, SvgModule
		, DateRangeComponent
		, DualListBoxComponent
		, RadioButtonListComponent
		, TouchRadioButtonListComponent
		, FileUploadComponent
		, FixedButtonsComponent
		, SubmitUrlDirective
		, BackButtonDirective
		, GoogleAddressComponent
		, PcgSelectComponent
		, ShowHidePasswordComponent
		, NoHashDirective
        , TextEditorComponent
	]
    , providers: [
		CurrencyService
		, SmartyStreetsService
	]
})
export class FormElementsModule {}
